import { Experiment } from '@cian/experiments/ab';
import { IconProductSaveSearch16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackSavedSearchesIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { useMobileBottomNavigation } from '../../hooks/useMobileBottomNavigation';
import { IApplicationState } from '../../types/redux';
import { useApplicationContext } from '../../utils/applicationContext';

export const UtilitySavedSearchesContainer: React.FC = () => {
  const {
    custom: { mainPageUrl },
  } = useApplicationContext();
  const savedSearchesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.savedSearches);
  const savedSearchesCount = useSelector<IApplicationState, number>(state => state.savedSearches.count);

  const isMobileBottomNavigationEnabled = useMobileBottomNavigation();

  if (!savedSearchesLink || isMobileBottomNavigationEnabled) {
    return null;
  }

  return (
    <>
      <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
        <Utility
          data-name="UtilitySavedSearchesContainer"
          title="Сохранённые поиски"
          unread={Boolean(savedSearchesCount)}
          icon={IconProductSaveSearch16}
          href={`${mainPageUrl}/favorites/?activeTab=savedSearches`}
          onClick={trackSavedSearchesIconClick}
        />
      </Experiment>
      <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="A" default>
        <Utility
          data-name="UtilitySavedSearchesContainer"
          title="Сохранённые поиски"
          unread={Boolean(savedSearchesCount)}
          icon={IconProductSaveSearch16}
          href={savedSearchesLink}
          onClick={trackSavedSearchesIconClick}
        />
      </Experiment>
    </>
  );
};
